import { createStore } from './utils';

type FollowChannelStore = {
  statusByChannelId: Record<string, boolean>;
  pendingByChannelId: Record<string, boolean>;
  hydrate: (chId: string, isFollowing: boolean | null | undefined) => void;
  setStatus: (chId: string, isFollowing: boolean) => void;
  setPending: (chId: string, pending: boolean) => void;
  reset: () => void;
};

export const useFollowChannelStore = createStore<FollowChannelStore>('FollowChannelStore', (set, get) => ({
  statusByChannelId: {},
  pendingByChannelId: {},
  hydrate: (chId, isFollowing) => {
    if (!chId || typeof isFollowing !== 'boolean') {
      return;
    }

    const state = get();
    if (state.pendingByChannelId[chId] || chId in state.statusByChannelId) {
      return;
    }

    set({
      statusByChannelId: {
        ...state.statusByChannelId,
        [chId]: isFollowing,
      },
    });
  },
  setStatus: (chId, isFollowing) => {
    if (!chId) {
      return;
    }

    set((state) => ({
      statusByChannelId: {
        ...state.statusByChannelId,
        [chId]: isFollowing,
      },
    }));
  },
  setPending: (chId, pending) => {
    if (!chId) {
      return;
    }

    set((state) => ({
      pendingByChannelId: {
        ...state.pendingByChannelId,
        [chId]: pending,
      },
    }));
  },
  reset: () => set({ statusByChannelId: {}, pendingByChannelId: {} }),
}));
